import { angular2react } from '@Shared.Angular/flowingly.helper/angular2react';
import { ProcessMapTabStepForm } from '@Client/runner.processmapsv2/components/View/RightPanel/StepForm/runner.processmap.tab.step-form';

type Props = {
  selectedNode: unknown;
  dynamicHeight: boolean;
};

export const ProcessMapStepForm = angular2react<Props>(
  'processmapTabStepForm',
  new ProcessMapTabStepForm()
);
